import { filterPlans } from "@helpers/content/tag";
import type { BundleDetails } from "@memorang/types";

const fetchBundleDetails = async (_bundleId: number) => {
	const bundleDetails = {
		bundle: {
			id: "",
			description: "",
			name: "",
			examName: "",
			icon: { id: "", url: "" },
			bundleType: "PRACTICE_TEST" as const,
			contentsItemsCount: { numFacts: 0, numQuestions: 0, numTerms: 0 },
			purchasable: false,
			numericId: 0,
			features: [],
			plans: [],
		},
		metadata: {
			subscription: {
				status: "",
				endDate: "",
				isLegacy: false,
				startDate: "",
				hasRenewed: false,
			},
		},
	} as unknown as BundleDetails;

	const filteredPlans = filterPlans(bundleDetails.bundle.plans);

	return {
		...bundleDetails,
		bundle: {
			...bundleDetails.bundle,
			plans: filteredPlans,
		},
	};
};

export default fetchBundleDetails;
